export enum Condition {
    Is = 2,
    IsNot = 3,
    StartsWith = 4,
    Includes = 6
}
